import { BasicFun } from 'ballerina-core'
import { Sum } from 'widgets-for-react'

export type APIResult<T> = Sum<{ status: number; message: string }, T>

export const APIResult = {
  Default: {
    Error: <T>(status: number, message: string): APIResult<T> => ({ kind: 'l', v: { status, message } }),
    Result: <T>(value: T): APIResult<T> => ({ kind: 'r', v: value }),
  },
  Operations: {
    hasValue: <T>(apiResult: APIResult<T>): apiResult is APIResult<T> & { kind: 'r' } => apiResult.kind == 'r',
    map:
      <T1, T2>(f: BasicFun<T1, T2>) =>
      (apiResult: APIResult<T1>): APIResult<T2> =>
        apiResult.kind == 'r'
          ? APIResult.Default.Result(f(apiResult.v))
          : APIResult.Default.Error(apiResult.v.status, apiResult.v.message),
  },
}
